import { useTranslation } from "react-i18next";
import { MOCK_ADDONS } from "../../../mocks/MOCK_services";

interface AddonsStepProps {
  selected: string[];
  onToggle: (addonId: string) => void;
  onNext: () => void;
  onBack: () => void;
}

export default function AddonsStep({ selected, onToggle, onNext, onBack }: AddonsStepProps) {
  const { t } = useTranslation();

  return (
    <div className="w-full max-w-2xl mx-auto px-6">
      <div className="text-center mb-4">
        <h2 className="text-3xl lg:text-4xl font-extralight text-[#2C2C2C] mb-3" style={{ letterSpacing: "-0.02em" }}>
          {t("tabifoto.booking.select_addons")}
        </h2>
        <div className="w-8 h-px bg-[#C8B8A6] mx-auto mb-4" />
        <p className="text-xs text-[#2C2C2C]/40 tracking-wide">
          {t("tabifoto.booking.addons_note")}
        </p>
      </div>

      <div className="mt-10 flex flex-col gap-4">
        {MOCK_ADDONS.map((addon) => {
          const isSelected = selected.includes(addon.id);
          return (
            <div
              key={addon.id}
              onClick={() => onToggle(addon.id)}
              className={`flex items-center gap-5 p-5 rounded-lg border cursor-pointer transition-all duration-200 ${
                isSelected
                  ? "border-[#C8B8A6] bg-[#C8B8A6]/5"
                  : "border-[#D9D9D9] hover:border-[#C8B8A6]/50 bg-white"
              }`}
            >
              {/* Checkbox */}
              <div
                className={`w-5 h-5 flex items-center justify-center rounded border shrink-0 transition-all duration-200 ${
                  isSelected ? "bg-[#C8B8A6] border-[#C8B8A6]" : "border-[#D9D9D9]"
                }`}
              >
                {isSelected && <i className="ri-check-line text-white text-xs" />}
              </div>

              {/* Image */}
              <div className="w-14 h-14 rounded overflow-hidden shrink-0">
                <img
                  src={addon.image}
                  alt={t(addon.title_key)}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Text */}
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-4 h-4 flex items-center justify-center text-[#C8B8A6]">
                    <i className={`${addon.icon} text-sm`} />
                  </div>
                  <h4 className="text-sm font-light text-[#2C2C2C]">
                    {t(addon.title_key)}
                  </h4>
                  <span className="ml-auto text-xs text-[#2C2C2C]/30 border border-[#D9D9D9] px-2 py-0.5 rounded-full whitespace-nowrap">
                    {t("tabifoto.booking.external_partner")}
                  </span>
                </div>
                <p className="text-xs text-[#2C2C2C]/40 font-light leading-relaxed">
                  {t(addon.desc_key)}
                </p>
              </div>
            </div>
          );
        })}
      </div>

      <div className="flex justify-between mt-10">
        <button
          onClick={onBack}
          className="px-6 py-3 rounded-full border border-[#D9D9D9] text-sm tracking-widest uppercase text-[#2C2C2C]/50 hover:border-[#2C2C2C] hover:text-[#2C2C2C] transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          ← {t("tabifoto.booking.back")}
        </button>
        <button
          onClick={onNext}
          className="px-8 py-3 rounded-full bg-[#2C2C2C] text-white text-sm tracking-widest uppercase hover:bg-[#2C2C2C]/80 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          {t("tabifoto.booking.next")} →
        </button>
      </div>
    </div>
  );
}
